import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import api from '../../../api/Categories.api';
import { SORT, CATEGORIES_ENTITIES_VISIBLE_COUNT, CATEGORIES_DEFAULT_SORT } from './../../../constants';
import {BoldedCell, TextCell} from '../Components';
import withSelection from './../hoc/Selectable';
import TableGrid from './../TableGrid';
import { sortBy } from 'lodash';

const Table = withSelection(TableGrid)

const defaultLoadParams = {
    filters: { query: "" },
    sorting: {
        sortBy: "name",
        direction: SORT.ASC
    },
    pagination: { pageNumber: 0 },
    reset: false
};

class CategoryTable extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        selectedCategoriesIds: PropTypes.array
    };

    static defaultProps = {
        selectedCategoriesIds: []
    }

    constructor(props) {
        super(props);
        this.state = {
            categoryNames: {},
            listItems: null,
            currentPage: 0,
            totalCount: 0,
            filterCount: 0,
            loadParams: defaultLoadParams,
            selectedItems: []
        };

        this.loadItems = this.loadItems.bind(this);
        this.handleErrorState = this.handleErrorState.bind(this);
        this.selectAllToggle = this.selectAllToggle.bind(this);
        this.handleSelectionChange = this.handleSelectionChange.bind(this);
        this.loadParams = defaultLoadParams;
    }

    componentDidMount() {
        this.loadItems();
    }

    loadItems() {
        let { filters, sorting, reset } = { ...this.loadParams };

        return api.count(filters).then((countRes) => {
            return api.get(filters, sorting, {
                pageNumber: -1,
                pageSize: -1
            }).then((response) => {
                const listItems = response.body
                const listItemsIds = listItems.map(item => item.category.id)
                const selectedItems = this.props.selectedCategoriesIds
                    .filter(itemId => listItemsIds.indexOf(itemId) > -1)
                    .map(categoryId => this.formatCategoryItem(listItems.filter(item => item.category.id === categoryId)[0]))
                this.setState({
                    listItems,
                    selectedItems,
                    filterCount: countRes.body,
                    totalCount: countRes.body
                });

                //this.props.spinner.off();
                return this.state.listItems
            })
        })
    }

    /**
     * View function for items in table
     * @param item
     * @param searchTerm
     * @returns {{key, companyTitle: XML, status: string, duns: (string|string|*), categoryIDs: XML, object: *}}
     */
    formatCategoryItem = (item, searchTerm = "") => {
        return {
            key: item.category.id,
            name: <TextCell>{item.category.name}</TextCell>,
            object: item
        }
    };

    /**
     * Handler for selection change
     * @param selectedItems
     */
    handleSelectionChange(selectedItems) {
        this.setState({ selectedItems });
        if (this.props.onChange) {
            this.props.onChange(selectedItems.map(item => item.object.category.id));
        }
    };


    /**
     * View function for item in selected box
     * @param item
     */
    formatSelectedItem = (item) => <span>{item.name}</span>;

    selectAllToggle() {
        if (this.state.selectedItems.length === this.state.totalCount) {
            this.handleSelectionChange([]);
        } else {
            api.get(defaultLoadParams.filters, defaultLoadParams.sorting, { pageNumber: -1, pageSize: -1 }).then(items => {
                this.handleSelectionChange(items.body.map(item => this.formatCategoryItem(item)));
            })
        }
    }

    /**
     * Resets state in case of error
     */
    handleErrorState(e) {
        console.log('Error caught', e);
        this.setState({
            listItems: [],
            totalCount: 0,
            itemCount: 0,

        });
        this.loadItems();
    }

    headerItems = [
        {
            key: "name",
            label: "Name",
            sortable: true
        }
    ]

    render() {
        const itemsCount = <div className={"counter"}><span className="counter-value">{this.state.totalCount} </span>
            <FormattedMessage id={"RSS_Add_UIText_addRssFeed.thirdParties.results"}/>
        </div>;
        return <div className="selectable-table category-table grid-view">
            <Table headerItems={this.headerItems}
                   listItems={this.state.listItems ? this.state.listItems.map(item => this.formatCategoryItem(item, this.state.searchTerm)) : null}
                   noEntries={this.noEntries}
                   className="selectable-table"
                   totalCount={this.state.totalCount}
                   filterCount={this.state.filterCount}
                   itemCount={this.state.filterCount}
                   defaultSort={CATEGORIES_DEFAULT_SORT}
                   onSelectionChange={this.handleSelectionChange}
                   selectedItems={sortBy(this.state.selectedItems, item => item.name.props.children.toLowerCase())}
                   formatSelectedItem={this.formatSelectedItem}
                   selectAllToggle={this.selectAllToggle}
                   actions={itemsCount}/>
        </div>;
    }
}

export default CategoryTable;


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/specific/CategoryTable.jsx